import { createUser, signInUser } from "../api/api";
import Cookies from "js-cookie";

export const registerUser =
  (fullname, email, password, navigate, setCookie) => async (dispatch) => {
    try {
      dispatch({
        type: "USER_REGISTER_REQUEST",
      });
      const res = await createUser({
        name: fullname,
        email: email,
        password: password,
      });

      if (res.status === 200) {
        if (res.data.access_token) {
          console.log(res.data);
          setCookie(
            "token",
            res.data.access_token,
            process.env.SESSION_EXPIRING_TIME
          );
          localStorage.setItem("token", res.data.access_token);
          localStorage.setItem("userInfo", JSON.stringify(res.data.user));

          dispatch({ type: "USER_REGISTER_SUCCESS", payload: res.data });

          navigate("/space");
        } else {
          return res.data;
        }
      } else {
        dispatch({ type: "USER_REGISTER_FAIL", payload: "err" });
      }
    } catch (err) {
      dispatch({
        type: "USER_REGISTER_FAIL",
        payload: err,
      });
      return err.response?.data;
    }
  };

export const logoutUser = () => (dispatch) => {
  localStorage.removeItem("token");
  localStorage.removeItem("userInfo");
  localStorage.removeItem("workspaceID");
  Cookies.remove("token", { path: "/" });

  // Dispatch logout action to clear the Redux state
  dispatch({ type: "USER_LOGOUT" });
};

// Login action
export const loginUser =
  (email, password, navigate, setCookie, from, apiKey, redirectUri) =>
  async (dispatch) => {
    try {
      dispatch({ type: "USER_LOGIN_REQUEST" });

      const res = await signInUser({ email: email, password: password });

      console.log(res);
      if (res.status === 200) {
        if (res.data.access_token) {
          await new Promise((resolve) => {
            setCookie("token", res.data.access_token, {
              maxAge: process.env.SESSION_EXPIRING_TIME,
            });
            localStorage.setItem("token", res.data.access_token);
            localStorage.setItem("userInfo", JSON.stringify(res.data.user));
            resolve();
          });

          dispatch({ type: "USER_LOGIN_SUCCESS", payload: res.data });

          navigate("/space");
        } else {
          return res?.data;
        }
      } else {
        dispatch({ type: "USER_LOGIN_FAIL", payload: "Login failed" });
      }
    } catch (error) {
      // Handle errors by dispatching the fail action with the error message
      dispatch({
        type: "USER_LOGIN_FAIL",
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : "Invalid username or password",
      });
    }
  };

// validate oauth token and uri
export const validateOAuthTokenAndUri =
  (apiKey, redirectUri) => async (dispatch) => {
    try {
      dispatch({ type: "OAUTH_TOKEN_VALIDATION_REQUEST" });
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/auth/oauth/validate?redirectUri=${redirectUri}&apiKey=${apiKey}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (res.ok) {
        const data = await res.json();
        dispatch({ type: "OAUTH_TOKEN_VALIDATION_SUCCESS", payload: data });
        return data;
      } else {
        const errorData = await res.json();
        dispatch({
          type: "OAUTH_TOKEN_VALIDATION_FAIL",
          payload: errorData.message,
        });
        return null;
      }
    } catch (error) {
      dispatch({ type: "OAUTH_TOKEN_VALIDATION_FAIL", payload: error.message });
      return null;
    }
  };

export const extendOAuthSession =
  (apiKey, redirectUri , accessToken) => async (dispatch) => {
    try {
      dispatch({ type: "OAUTH_SESSION_EXTENSION_REQUEST" });
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/auth/oauth/extend?redirectUri=${redirectUri}&apiKey=${apiKey}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
          },
        }
      );
      if (res?.ok) {
        const data = await res?.json();
        dispatch({ type: "OAUTH_SESSION_EXTENSION_SUCCESS", payload: data });
        return data;
      } else {
        const errorData = await res?.json();
        dispatch({
          type: "OAUTH_SESSION_EXTENSION_FAIL",
          payload: errorData?.message,
        });
        return null;
      }
    } catch (error) {
      dispatch({ type: "OAUTH_SESSION_EXTENSION_FAIL", payload: error.message });
      return null;
    }
  };

// signin via oauth
